import { createApp, defineAsyncComponent } from 'vue';
import { trimEmptyTextNodes } from '@/client/directives/TrimWhitespace';
import App from '@/client/components/App.vue';
import { getPreferences } from '@/client/utils/PreferencesManager';
import { applyUiScale } from '@/client/utils/uiScale';
import i18nPlugin from '@/client/plugins/i18n.plugin';
import { startOauth } from '@/client/oauth';
const PlayerInputFactory = defineAsyncComponent(() => import(/* webpackChunkName: "player-input" */ '@/client/components/PlayerInputFactory.vue'));
async function bootstrap() {
    // Text and screen size (settings), before anything is drawn.
    applyUiScale();
    const lang = getPreferences().lang;
    if (lang !== 'en') {
        try {
            window._translations = await fetch(`assets/locales/${lang}.json`).then((res) => res.json());
        }
        catch (err) {
            console.warn(`Cannot load ${lang} translations. See network for details.`);
        }
    }
    const app = createApp(App);
    app.use(i18nPlugin);
    app.component('PlayerInputFactory', PlayerInputFactory);
    app.directive('trim-whitespace', {
        mounted: trimEmptyTextNodes,
        updated: trimEmptyTextNodes,
    });
    if (window.isSecureContext && 'serviceWorker' in navigator) {
        const register = () => {
            navigator.serviceWorker.register('sw.js').then(function (registration) {
                console.log('registered the service worker', registration);
            });
        };
        // Offline: with a language other than English, the translations are fetched first and the page has usually
        // finished loading by now, so waiting for 'load' would never register the service worker.
        if (document.readyState === 'complete') {
            register();
        }
        else {
            window.addEventListener('load', register);
        }
    }
    app.mount('#app');
    window.onload = startOauth;
}
bootstrap();
